module.exports = __webpack_public_path__ + "static/img/componyBackground.efb6cf1f.svg";